const sizeButton = document.getElementById("rdm-bb-size-button");
const sizePopup = document.getElementById("rdm-bb-size-popup");
const closePopup = document.getElementsByClassName("rdm-bb-size-popup-close")[0];
const tipTemplate = document.getElementById('rdm-bb-template');
const tipInput = document.getElementById('rdm-bb-tip');
const tektutar = document.getElementById('tektutar');
const tektoplam = document.getElementById('tektoplam');
const ikitutar = document.getElementById('ikitutar');
const ikitoplam = document.getElementById('ikitoplam');
const uctutar = document.getElementById('uctutar');
const uctoplam = document.getElementById('uctoplam');

document.addEventListener('DOMContentLoaded', function() {

  const templatetip = tipTemplate.value;
  const tip = tipInput.value;
  const noktaliTip = tip.replace(/\./g, '').replace(",", "");
  const floatTip = parseFloat(noktaliTip);
  
  //const indirimliTip = floatTip * 0.85;
  const indirimliTip = floatTip;
  
  /*if(templatetip != "piercingfirsat"){
    indirimliTip = floatTip * 0.85;
  } else {
    indirimliTip = floatTip;
  }*/
  
  tektutar.innerText = indirimliTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  const ikiTip = indirimliTip / 2;
  ikitutar.innerText = ikiTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  const ucTip = indirimliTip / 3;
  uctutar.innerText = ucTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  tektoplam.innerText = indirimliTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  ikitoplam.innerText = indirimliTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  uctoplam.innerText = indirimliTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;

});


sizeButton.addEventListener("click", function() {
  sizePopup.style.display = "block";
  
  
});

closePopup.addEventListener("click", function() {
  sizePopup.style.display = "none";
});

window.addEventListener("click", function(event) {
  if (event.target == sizePopup) {
    sizePopup.style.display = "none";
  }
});


var textinputs = [
    { id: 'ymq-attrib-12', maxlength: '1' },
    { id: 'ymq-attrib-11', maxlength: '2' },
    { id: 'ymq-attrib-10', maxlength: '3' },
    { id: 'ymq-attrib-9', maxlength: '4' },
    { id: 'ymq-attrib-4', maxlength: '5' },
    { id: 'ymq-attrib-5', maxlength: '6' },
    { id: 'ymq-attrib-6', maxlength: '7' },
    { id: 'ymq-attrib-7', maxlength: '8' }
];

    function addToTextbox(symbol) {
        var selectedValue = document.getElementById('ymq-attrib-3').value;
        var inputToUpdate;
        var manmaxlength;

        if (selectedValue === '1 HARF') {
            inputToUpdate = document.getElementById('ymq-attrib-12');
            manmaxlength = 1;
        } else if (selectedValue === '2 HARF') {
            inputToUpdate = document.getElementById('ymq-attrib-11');
            manmaxlength = 2;
        } else if (selectedValue === '3 HARF') {
            inputToUpdate = document.getElementById('ymq-attrib-10');
            manmaxlength = 3;
        } else if (selectedValue === '4 HARF') {
            inputToUpdate = document.getElementById('ymq-attrib-9');
            manmaxlength = 4;
        } else if (selectedValue === '5 HARF') {
            inputToUpdate = document.getElementById('ymq-attrib-4');
            manmaxlength = 5;
        } else if (selectedValue === '6 HARF') {
            inputToUpdate = document.getElementById('ymq-attrib-5');
            manmaxlength = 6;
        } else if (selectedValue === '7 HARF') {
            inputToUpdate = document.getElementById('ymq-attrib-6');
            manmaxlength = 7;
        } else if (selectedValue === '8 HARF') {
            inputToUpdate = document.getElementById('ymq-attrib-7');
            manmaxlength = 8;
        }

        console.log("selectedValue: " + selectedValue);
        console.log("inputToUpdate: " + inputToUpdate);

        if (inputToUpdate) {

          
            //var maxLength = inputToUpdate.getAttribute('maxlength');
            console.log("inputToUpdate: " + inputToUpdate);
            console.log("manmaxlength: " + manmaxlength);
          
            if (inputToUpdate.value.length < manmaxlength) {
                inputToUpdate.value += symbol.toUpperCase();
                updatePreview(inputToUpdate.value);
            } else {
                console.log('Maksimum uzunluk aşıldı');
            }

          
        }
      
        /*if (inputToUpdate) {
            inputToUpdate.value += symbol.toUpperCase();
            updatePreview(inputToUpdate.value);
        }*/

      
        // Clear other text inputs
        var allTextInputs = document.querySelectorAll('.isimelementi input[type="text"]');
        allTextInputs.forEach(function(input) {
            if (input !== inputToUpdate) {
                input.value = '';
            }
        });
    }

    function updatePreview(value) {
        var previewElement = document.querySelector('.text-onizleme .ymq_custome_text');
        // Her harfi <span> içine al
    var formattedText = value.split('').map(function(char) {
        return `<span>${char}</span>`;
    }).join('');
    
    // Güncellenmiş metni içeriğe ekle
    previewElement.innerHTML = formattedText;
    }

  document.addEventListener('DOMContentLoaded', function() {
      var allTextInputs = document.querySelectorAll('.isimelementi input[type="text"]');
      console.log("allTextInputs: " + allTextInputs); // Elementlerin doğru şekilde seçilip seçilmediğini kontrol edin
  
      allTextInputs.forEach(function(input) {
          input.addEventListener('input', function() {
              this.value = this.value.toUpperCase();
              updatePreview(this.value);
  
              // Clear other text inputs
              allTextInputs.forEach(function(otherInput) {
                  if (otherInput !== input) {
                      otherInput.value = '';
                  }
              });
          });
      });

      var targetDiv = document.querySelector('div[data-name="properties[Zincir Uzunluğu]"]');
      if (targetDiv) {
          var priceSpans = targetDiv.querySelectorAll('.ymq_r_c_box .ymq-price-span');
          priceSpans.forEach(function(span) {
              //span.classList.add('d-none');
          });
          var pricesplitSpans = targetDiv.querySelectorAll('.ymq_r_c_box .ymq-price-split');
          pricesplitSpans.forEach(function(span) {
              //span.classList.add('d-none');
              span.innerHTML = '/' + span.innerHTML;
          });
      }

    

    textinputs.forEach(function(input) {
        var inputElement = document.getElementById(input.id);
        if (inputElement) {
            inputElement.setAttribute('maxlength', input.maxlength);
        }
    });

    
    document.getElementById('ymq-attrib-3').addEventListener('change', function() {
        var previewDiv = document.querySelector('.text-onizleme');
        if (this.value === "") {
            previewDiv.style.display = 'none';
        } else {
            previewDiv.style.display = 'block';
        }
    });
    
    
  });



window.onload = function() {
    var pageURL = window.location.href;
    var productContainer = document.querySelector('[data-product-id="7707163623539-template--14687048761459__main"]');
    
    if (productContainer) {
        var ymqLabelZincir = productContainer.querySelector("#option-box-2 .ymq-option-title .ymq_lable");
        var ymqLabelHarf = productContainer.querySelector("#option-box-3 .ymq-option-title .ymq_lable");
        var ymqLabelHarfSelect = productContainer.querySelector("#option-box-3 #ymq-attrib-3 .ymq-options-default");
        var ymqLabelHarfNote = productContainer.querySelector("#option-box-3 .ymq_help_box p b");
        var ymqBoxPriceAddons = productContainer.querySelector("#ymq-box #ymq-price-addons");

        var ymqLabelHarfSelectElements = [
            "ymq-attrib-3_5",
            "ymq-attrib-3_6",
            "ymq-attrib-3_7",
            "ymq-attrib-3_8",
            "ymq-attrib-3_9",
            "ymq-attrib-3_2",
            "ymq-attrib-3_3",
            "ymq-attrib-3_4"
        ];

        if (pageURL.includes("/en/products")) {
            ymqLabelZincir.textContent = "Chain Length";
            ymqLabelHarf.textContent = "Number of Letters";
            ymqLabelHarfSelect.textContent = "Please Select";
            ymqLabelHarfNote.textContent = "(Priced at 1,700 TL per letter/symbol)";
            ymqBoxPriceAddons.innerHTML = 'Extra amount to be added to your cart <span id="ymq-addons-price"></span>';

            updateMultipleTextNodes(productContainer, ymqLabelHarfSelectElements, [
                "1 Letter", "2 Letter", "3 Letter", "4 Letter", 
                "5 Letter", "6 Letter", "7 Letter", "8 Letter"
            ]);

            updateIsimElementText(productContainer, "Enter Text", "You can also add the following characters.");
            
        } else if (pageURL.includes("/ru/products")) {
            ymqLabelZincir.textContent = "Длина цепочки";
            ymqLabelHarf.textContent = "Количество букв";
            ymqLabelHarfSelect.textContent = "Выберите, пожалуйста";
            ymqLabelHarfNote.textContent = "(Стоимость составляет 1700 TL за букву/символ)";
            ymqBoxPriceAddons.innerHTML = 'Дополнительная сумма, которую нужно добавить в корзину <span id="ymq-addons-price"></span>';

            updateMultipleTextNodes(productContainer, ymqLabelHarfSelectElements, [
                "1 буква", "2 буква", "3 буква", "4 буква", 
                "5 буква", "6 буква", "7 буква", "8 буква"
            ]);

            updateIsimElementText(productContainer, "Введите текст", "Вы также можете добавить следующие символы.");
          
        } else {
            
        }
    }
};

function updateMultipleTextNodes(container, elementIds, newTexts) {
    elementIds.forEach(function(elementId, index) {
        var element = container.querySelector("#" + elementId);

        if (element && index < newTexts.length) {
            var textNode = element.childNodes[0];

            if (textNode && textNode.nodeType === Node.TEXT_NODE) {
                textNode.nodeValue = newTexts[index];
            }
        }
    });
}

function updateIsimElementText(container, newText, newNote) {
    var isimElements = container.querySelectorAll(".isimelementi .ymq_lable");
    var isimElementsHelp = container.querySelectorAll(".isimelementi .ymq_help_box p");
    
    isimElements.forEach(function(element) {
        element.textContent = newText;
    });

    isimElementsHelp.forEach(function(element) {
        element.textContent = newNote;
    });
}




window.onload = function () {



/*var productContainer = document.querySelector('[data-product-id="7852411912307-template--14687048761459__main"]');*/
var productContainer = document.querySelector('[data-product-id="7852411912307-template--15626240458867__main"]');
const letterCount = document.querySelector('.gumus-harf-sayisi #ymq-attrib-2');
const nameInput = document.querySelector('.gumus-isim .ymq-input-text');
const namePreview = document.querySelector('.ymq_custome_text');
const symbolButtons = document.querySelectorAll('.gumus-symbol-btn');
const submitButton = document.querySelector('.product-buy-buttons--cta');
const gumusIsimDiv = document.querySelector('.gumus-isim');

if (productContainer) {
  const warningMessage = document.createElement('div');
  warningMessage.style.color = 'red';
  warningMessage.style.fontSize = '12px';
  warningMessage.style.display = 'none';
  nameInput.parentNode.insertBefore(warningMessage, nameInput);

  // Sayfa yüklendiğinde data-validate değerini ayarla
  gumusIsimDiv.setAttribute('data-validate', 'required|minchar:1|maxchar:1');
  nameInput.maxLength = 1;

  letterCount.addEventListener('change', () => {
    const selectedOption = letterCount.options[letterCount.selectedIndex];
    const maxLength = parseInt(selectedOption.value.match(/^\d+/)?.[0], 10) || 0;
    
    // data-validate attribute'ünü güncelle
    gumusIsimDiv.setAttribute('data-validate', `required|minchar:${maxLength}|maxchar:${maxLength}`);
    
    // Name input alanını sıfırla ve yeni uzunluğu ayarla
    nameInput.value = '';
    nameInput.maxLength = maxLength;
    nameInput.minLength = maxLength;
    checkInputValidity();
  });

  nameInput.addEventListener('input', () => {
    nameInput.value = nameInput.value.toUpperCase();
    namePreview.textContent = nameInput.value;

    const currentLength = nameInput.value.length;
    const minLength = parseInt(nameInput.minLength, 10) || 0;

    if (currentLength < minLength) {
      warningMessage.textContent = `Lütfen en az ${minLength} karakter giriniz.`;
      warningMessage.style.display = 'block';
    } else {
      warningMessage.style.display = 'none';
    }

    checkInputValidity();
  });

  symbolButtons.forEach(button => {
    button.addEventListener('click', () => {
      const symbol = button.textContent;

      if (nameInput.value.length < nameInput.maxLength) {
        nameInput.value += symbol;
        nameInput.dispatchEvent(new Event('input'));  // input olayını tetikle
      } else {
        alert(`En fazla ${nameInput.maxLength} karakter girebilirsiniz.`);
      }
    });
  });

  function checkInputValidity() {
    const currentLength = nameInput.value.length;
    const minLength = parseInt(nameInput.minLength, 10) || 0;

    submitButton.disabled = currentLength < minLength;
  }

  nameInput.addEventListener('focus', () => {
    nameInput.addEventListener('input', () => {
      if (nameInput.value.length > nameInput.maxLength) {
        nameInput.value = nameInput.value.slice(0, nameInput.maxLength);
      }
    });
  });


  // Kalp Renk Seçimi
  const colorOptions = document.querySelectorAll('.ymq-options-box[data-label="Renk"] input[type="radio"]');

  const heartColorLabel = document.querySelector('.ymq-attrib-item-13_1');

  if (!colorOptions.length || !heartColorLabel) return;

  colorOptions.forEach(option => {
      option.addEventListener("change", function () {
          const selectedLabel = document.querySelector(`label[for="${this.id}"]`);

          if (selectedLabel) {
              const newColor = selectedLabel.style.backgroundColor;
              
              heartColorLabel.style.backgroundColor = newColor;
          }
      });
  });
}
  









  // roma ürünü
  var productRomaContainer = document.querySelector('[data-product-id="6788538597491-template--14687048761459__main"]');
  const romaTarihInput = document.querySelector('.roma-tarih .ymq-hidden-input');
  const romaTarihPreview = document.querySelector('.roma-onizleme .ymq_custome_text');

  if (productRomaContainer) {
    //console.log("roma container ok");

    function toRoman(num) {
      const romanMap = [
        [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
        [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
        [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']
      ];
      let roman = '';
      for (const [value, numeral] of romanMap) {
        while (num >= value) {
          roman += numeral;
          num -= value;
        }
      }
      return roman;
    }

    // MutationObserver ile value değişikliğini izleme
    const observerRoma = new MutationObserver(() => {
      const dateValue = romaTarihInput.value;
      if (dateValue) {
        //console.log("roma tarih değişti:", dateValue);
        // Tarihi yıl, ay ve gün olarak ayır
        const [day, month, year] = dateValue.split('-').map(Number);

        // Romen rakamlarına çevir
        const romanYear = toRoman(year);
        const romanMonth = toRoman(month);
        const romanDay = toRoman(day);

        // Alt kısma sonucu yazdır (alt alta)
        romaTarihPreview.innerHTML = `
          <div>${romanDay}</div>
          <div>${romanMonth}</div>
          <div>${romanYear}</div>
        `;
      }
    });

    // Roma tarih input'un değer değişikliğini izler
    observerRoma.observe(romaTarihInput, {
      attributes: true, // Özellik değişikliklerini izle
      attributeFilter: ['value'] // Sadece `value` özelliğini izle
    });
  }






  
};

